module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Rbfoo8/tc-custom/9781607058816.jpg?1728293326512",
      "alt": "This image is the cover for the book Scrappy Bits Appliqué"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scrappy Bits Appliqué\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Go beyond basic scrap quilts with this guide to turning fabric bits snips into striking modern art quilts—featuring 8 quick and easy projects.")]), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("Scrappy Bits Applique")]), _vm._v(", fabric designer and quilt artist Shannon Brinkley shares her secrets to putting sewing room scraps to use. With her easy stitching and collage techniques, she shows how simplicity can produce dramatic results. "), _c('br'), _c('br'), _vm._v("Shannon’s “scrappy” approach to quilting uses a fast raw-edged technique. With step-by-step instructions, she teaches you how to intuitively choose, cut, and sew bits of fabric to create a collage of unique images and textures. Included are eight engaging quilt projects to try out your new skills.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Shannon Brinkley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Shannon Brinkley is a self-taught quilter and designer of modern quilt patterns. She holds two teaching certifications and loves encouraging others to learn and try new things. She lives in Austin, Texas, with her family. Visit her website, thebottletree.net, to see her quilts and patterns.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0